/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetUploadByKeyQueryResponse, GetUploadByKeyPathParams } from "../models/GetUploadByKey";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getUploadByKey } from "../axios/getUploadByKey";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getUploadByKeyQueryKey = (key: GetUploadByKeyPathParams["key"], platform: GetUploadByKeyPathParams["platform"]) => ["social-export-api", { url: '/upload/by-key/:platform/:key', params: {platform:platform,key:key} }] as const

export type GetUploadByKeyQueryKey = ReturnType<typeof getUploadByKeyQueryKey>

export function getUploadByKeyQueryOptions(key: GetUploadByKeyPathParams["key"], platform: GetUploadByKeyPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getUploadByKeyQueryKey(key, platform)
        return queryOptions<GetUploadByKeyQueryResponse, ResponseErrorConfig<Error>, GetUploadByKeyQueryResponse, typeof queryKey>({
         enabled: !!(key&& platform),
         queryKey,
         queryFn: async ({ signal }) => {
            return getUploadByKey(key, platform, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get upload by platform and key
 * {@link /upload/by-key/:platform/:key}
 */
export function useGetUploadByKey<TData = GetUploadByKeyQueryResponse, TQueryData = GetUploadByKeyQueryResponse, TQueryKey extends QueryKey = GetUploadByKeyQueryKey>(key: GetUploadByKeyPathParams["key"], platform: GetUploadByKeyPathParams["platform"], options: 
{
  query?: Partial<QueryObserverOptions<GetUploadByKeyQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getUploadByKeyQueryKey(key, platform)
         

         const query = useQuery({
          ...getUploadByKeyQueryOptions(key, platform, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}